import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/style.scss";
import "./i18n/config";
import App from "./App.tsx";
import ErrorBoundary from "./components/ErrorBoundary";
import ReduxProvider from "./redux/ReduxProvider";
import { initSentry, captureSentryException } from "./utils/sentry";

initSentry();

window.addEventListener("unhandledrejection", (event) => {
  captureSentryException(event.reason, { type: "unhandledrejection" });
});

window.onerror = (message, source, lineno, colno, error) => {
  captureSentryException(error ?? message, { source, lineno, colno });
};

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ReduxProvider>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </ReduxProvider>
  </StrictMode>
);
